import { getApiBaseUrl } from './apiBaseUrl'

export type GraphQLErrorItem = { message: string; extensions?: Record<string, unknown> }

export async function graphqlRequest<T>(
  query: string,
  variables?: Record<string, unknown>,
  extraHeaders?: HeadersInit,
  init?: { signal?: AbortSignal }
): Promise<T> {
  const res = await fetch(`${getApiBaseUrl()}/graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(extraHeaders || {}),
    },
    body: JSON.stringify({ query, variables }),
    signal: init?.signal,
  })

  let body: {
    data?: T
    errors?: GraphQLErrorItem[]
  }
  try {
    body = await res.json()
  } catch {
    throw new Error(`GraphQL: invalid JSON response (${res.status})`)
  }

  if (body.errors?.length) {
    const first = body.errors[0]
    const ext = first.extensions as { httpStatus?: number } | undefined
    const hint =
      ext?.httpStatus === 401
        ? 'Unauthorized'
        : ext?.httpStatus === 403
          ? 'Forbidden'
          : ext?.httpStatus === 429
            ? 'Rate limit'
            : ''
    const msg = [first.message, hint].filter(Boolean).join(' — ')
    throw new Error(msg || 'GraphQL error')
  }

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${res.statusText}`)
  }

  if (body.data === undefined) {
    throw new Error('GraphQL: missing data field')
  }

  return body.data
}
